const statesWithDistricts = [
    {
      "state_id": 1,
      "name": "Andhra Pradesh",
      "districts": [
        { "district_id": 1, "name": "Anantapur" },
        { "district_id": 2, "name": "Chittoor" },
        { "district_id": 3, "name": "East Godavari" },
        { "district_id": 4, "name": "Guntur" },
        { "district_id": 5, "name": "Krishna" },
        { "district_id": 6, "name": "Kurnool" },
        { "district_id": 7, "name": "Prakasam" },
        { "district_id": 8, "name": "Srikakulam" },
        { "district_id": 9, "name": "Sri Potti Sriramulu Nellore" },
        { "district_id": 10, "name": "Visakhapatnam" },
        { "district_id": 11, "name": "Vizianagaram" },
        { "district_id": 12, "name": "West Godavari" },
        { "district_id": 13, "name": "YSR Kadapa" }
      ]
    },
    {
      "state_id": 2,
      "name": "Arunachal Pradesh",
      "districts": [
        { "district_id": 14, "name": "Anjaw" },
        { "district_id": 15, "name": "Changlang" },
        { "district_id": 16, "name": "Dibang Valley" },
        { "district_id": 17, "name": "East Kameng" },
        { "district_id": 18, "name": "East Siang" },
        { "district_id": 19, "name": "Kamle" },
        { "district_id": 20, "name": "Kra Daadi" },
        { "district_id": 21, "name": "Kurung Kumey" },
        { "district_id": 22, "name": "Lepa Rada" },
        { "district_id": 23, "name": "Lohit" },
        { "district_id": 24, "name": "Longding" },
        { "district_id": 25, "name": "Lower Dibang Valley" },
        { "district_id": 26, "name": "Lower Siang" },
        { "district_id": 27, "name": "Lower Subansiri" },
        { "district_id": 28, "name": "Namsai" },
        { "district_id": 29, "name": "Pakke Kessang" },
        { "district_id": 30, "name": "Papum Pare" },
        { "district_id": 31, "name": "Shi Yomi" },
        { "district_id": 32, "name": "Siang" },
        { "district_id": 33, "name": "Tawang" },
        { "district_id": 34, "name": "Tirap" },
        { "district_id": 35, "name": "Upper Siang" },
        { "district_id": 36, "name": "Upper Subansiri" },
        { "district_id": 37, "name": "West Kameng" },
        { "district_id": 38, "name": "West Siang" }
      ]
    },
    {
      "state_id": 3,
      "name": "Assam",
      "districts": [
        { "district_id": 39, "name": "Baksa" },
        { "district_id": 40, "name": "Barpeta" },
        { "district_id": 41, "name": "Biswanath" },
        { "district_id": 42, "name": "Bongaigaon" },
        { "district_id": 43, "name": "Cachar" },
        { "district_id": 44, "name": "Charaideo" },
        { "district_id": 45, "name": "Chirang" },
        { "district_id": 46, "name": "Darrang" },
        { "district_id": 47, "name": "Dhemaji" },
        { "district_id": 48, "name": "Dhubri" },
        { "district_id": 49, "name": "Dibrugarh" },
        { "district_id": 50, "name": "Dima Hasao" },
        { "district_id": 51, "name": "Goalpara" },
        { "district_id": 52, "name": "Golaghat" },
        { "district_id": 53, "name": "Hailakandi" },
        { "district_id": 54, "name": "Hojai" },
        { "district_id": 55, "name": "Jorhat" },
        { "district_id": 56, "name": "Kamrup" },
        { "district_id": 57, "name": "Kamrup Metropolitan" },
        { "district_id": 58, "name": "Karbi Anglong" },
        { "district_id": 59, "name": "Karimganj" },
        { "district_id": 60, "name": "Kokrajhar" },
        { "district_id": 61, "name": "Lakhimpur" },
        { "district_id": 62, "name": "Majuli" },
        { "district_id": 63, "name": "Morigaon" },
        { "district_id": 64, "name": "Nagaon" },
        { "district_id": 65, "name": "Nalbari" },
        { "district_id": 66, "name": "Sivasagar" },
        { "district_id": 67, "name": "Sonitpur" },
        { "district_id": 68, "name": "South Salmara-Mankachar" },
        { "district_id": 69, "name": "Tinsukia" },
        { "district_id": 70, "name": "Udalguri" },
        { "district_id": 71, "name": "West Karbi Anglong" }
      ]
    },
    {
      "state_id": 4,
      "name": "Bihar",
      "districts": [
        { "district_id": 72, "name": "Araria" },
        { "district_id": 73, "name": "Arwal" },
        { "district_id": 74, "name": "Aurangabad" },
        { "district_id": 75, "name": "Banka" },
        { "district_id": 76, "name": "Begusarai" },
        { "district_id": 77, "name": "Bhagalpur" },
        { "district_id": 78, "name": "Bhojpur" },
        { "district_id": 79, "name": "Buxar" },
        { "district_id": 80, "name": "Darbhanga" },
        { "district_id": 81, "name": "East Champaran" },
        { "district_id": 82, "name": "Gaya" },
        { "district_id": 83, "name": "Gopalganj" },
        { "district_id": 84, "name": "Jamui" },
        { "district_id": 85, "name": "Jehanabad" },
        { "district_id": 86, "name": "Kaimur" },
        { "district_id": 87, "name": "Katihar" },
        { "district_id": 88, "name": "Khagaria" },
        { "district_id": 89, "name": "Kishanganj" },
        { "district_id": 90, "name": "Lakhisarai" },
        { "district_id": 91, "name": "Madhepura" },
        { "district_id": 92, "name": "Madhubani" },
        { "district_id": 93, "name": "Munger" },
        { "district_id": 94, "name": "Muzaffarpur" },
        { "district_id": 95, "name": "Nalanda" },
        { "district_id": 96, "name": "Nawada" },
        { "district_id": 97, "name": "Patna" },
        { "district_id": 98, "name": "Purnia" },
        { "district_id": 99, "name": "Rohtas" },
        { "district_id": 100, "name": "Saharsa" },
        { "district_id": 101, "name": "Samastipur" },
        { "district_id": 102, "name": "Saran" },
        { "district_id": 103, "name": "Sheikhpura" },
        { "district_id": 104, "name": "Sheohar" },
        { "district_id": 105, "name": "Sitamarhi" },
        { "district_id": 106, "name": "Siwan" },
        { "district_id": 107, "name": "Supaul" },
        { "district_id": 108, "name": "Vaishali" },
        { "district_id": 109, "name": "West Champaran" }
      ]
    },
    {
      "state_id": 5,
      "name": "Chhattisgarh",
      "districts": [
        { "district_id": 110, "name": "Balod" },
        { "district_id": 111, "name": "Baloda Bazar" },
        { "district_id": 112, "name": "Balrampur" },
        { "district_id": 113, "name": "Bastar" },
        { "district_id": 114, "name": "Bemetara" },
        { "district_id": 115, "name": "Bijapur" },
        { "district_id": 116, "name": "Bilaspur" },
        { "district_id": 117, "name": "Dantewada" },
        { "district_id": 118, "name": "Dhamtari" },
        { "district_id": 119, "name": "Durg" },
        { "district_id": 120, "name": "Gariaband" },
        { "district_id": 121, "name": "Gaurela-Pendra-Marwahi" },
        { "district_id": 122, "name": "Janjgir-Champa" },
        { "district_id": 123, "name": "Jashpur" },
        { "district_id": 124, "name": "Kabirdham" },
        { "district_id": 125, "name": "Kanker" },
        { "district_id": 126, "name": "Kondagaon" },
        { "district_id": 127, "name": "Korba" },
        { "district_id": 128, "name": "Koriya" },
        { "district_id": 129, "name": "Mahasamund" },
        { "district_id": 130, "name": "Mungeli" },
        { "district_id": 131, "name": "Narayanpur" },
        { "district_id": 132, "name": "Raigarh" },
        { "district_id": 133, "name": "Raipur" },
        { "district_id": 134, "name": "Rajnandgaon" },
        { "district_id": 135, "name": "Sukma" },
        { "district_id": 136, "name": "Surajpur" },
        { "district_id": 137, "name": "Surguja" }
      ]
    },
    {
      "state_id": 6,
      "name": "Goa",
      "districts": [
        { "district_id": 138, "name": "North Goa" },
        { "district_id": 139, "name": "South Goa" }
      ]
    },
    {
      "state_id": 7,
      "name": "Gujarat",
      "districts": [
        { "district_id": 140, "name": "Ahmedabad" },
        { "district_id": 141, "name": "Amreli" },
        { "district_id": 142, "name": "Anand" },
        { "district_id": 143, "name": "Aravalli" },
        { "district_id": 144, "name": "Banaskantha" },
        { "district_id": 145, "name": "Bharuch" },
        { "district_id": 146, "name": "Bhavnagar" },
        { "district_id": 147, "name": "Botad" },
        { "district_id": 148, "name": "Chhota Udaipur" },
        { "district_id": 149, "name": "Dahod" },
        { "district_id": 150, "name": "Dang" },
        { "district_id": 151, "name": "Devbhoomi Dwarka" },
        { "district_id": 152, "name": "Gandhinagar" },
        { "district_id": 153, "name": "Gir Somnath" },
        { "district_id": 154, "name": "Jamnagar" },
        { "district_id": 155, "name": "Junagadh" },
        { "district_id": 156, "name": "Kheda" },
        { "district_id": 157, "name": "Kutch" },
        { "district_id": 158, "name": "Mahisagar" },
        { "district_id": 159, "name": "Mehsana" },
        { "district_id": 160, "name": "Morbi" },
        { "district_id": 161, "name": "Narmada" },
        { "district_id": 162, "name": "Navsari" },
        { "district_id": 163, "name": "Panchmahal" },
        { "district_id": 164, "name": "Patan" },
        { "district_id": 165, "name": "Porbandar" },
        { "district_id": 166, "name": "Rajkot" },
        { "district_id": 167, "name": "Sabarkantha" },
        { "district_id": 168, "name": "Surat" },
        { "district_id": 169, "name": "Surendranagar" },
        { "district_id": 170, "name": "Tapi" },
        { "district_id": 171, "name": "Vadodara" },
        { "district_id": 172, "name": "Valsad" }
      ]
    },
    {
      "state_id": 8,
      "name": "Haryana",
      "districts": [
        { "district_id": 173, "name": "Ambala" },
        { "district_id": 174, "name": "Bhiwani" },
        { "district_id": 175, "name": "Charkhi Dadri" },
        { "district_id": 176, "name": "Faridabad" },
        { "district_id": 177, "name": "Fatehabad" },
        { "district_id": 178, "name": "Gurugram" },
        { "district_id": 179, "name": "Hisar" },
        { "district_id": 180, "name": "Jhajjar" },
        { "district_id": 181, "name": "Jind" },
        { "district_id": 182, "name": "Kaithal" },
        { "district_id": 183, "name": "Karnal" },
        { "district_id": 184, "name": "Kurukshetra" },
        { "district_id": 185, "name": "Mahendragarh" },
        { "district_id": 186, "name": "Nuh" },
        { "district_id": 187, "name": "Palwal" },
        { "district_id": 188, "name": "Panchkula" },
        { "district_id": 189, "name": "Panipat" },
        { "district_id": 190, "name": "Rewari" },
        { "district_id": 191, "name": "Rohtak" },
        { "district_id": 192, "name": "Sirsa" },
        { "district_id": 193, "name": "Sonipat" },
        { "district_id": 194, "name": "Yamunanagar" }
      ]
    },
    {
      "state_id": 9,
      "name": "Himachal Pradesh",
      "districts": [
        { "district_id": 195, "name": "Bilaspur" },
        { "district_id": 196, "name": "Chamba" },
        { "district_id": 197, "name": "Hamirpur" },
        { "district_id": 198, "name": "Kangra" },
        { "district_id": 199, "name": "Kinnaur" },
        { "district_id": 200, "name": "Kullu" },
        { "district_id": 201, "name": "Lahaul and Spiti" },
        { "district_id": 202, "name": "Mandi" },
        { "district_id": 203, "name": "Shimla" },
        { "district_id": 204, "name": "Sirmaur" },
        { "district_id": 205, "name": "Solan" },
        { "district_id": 206, "name": "Una" }
      ]
    },
    {
        "state_id": 10,
        "name": "Jharkhand",
        "districts": [
          { "district_id": 207, "name": "Bokaro" },
          { "district_id": 208, "name": "Chatra" },
          { "district_id": 209, "name": "Deoghar" },
          { "district_id": 210, "name": "Dhanbad" },
          { "district_id": 211, "name": "Dumka" },
          { "district_id": 212, "name": "East Singhbhum" },
          { "district_id": 213, "name": "Garhwa" },
          { "district_id": 214, "name": "Giridih" },
          { "district_id": 215, "name": "Godda" },
          { "district_id": 216, "name": "Gumla" },
          { "district_id": 217, "name": "Hazaribagh" },
          { "district_id": 218, "name": "Jamtara" },
          { "district_id": 219, "name": "Khunti" },
          { "district_id": 220, "name": "Koderma" },
          { "district_id": 221, "name": "Latehar" },
          { "district_id": 222, "name": "Lohardaga" },
          { "district_id": 223, "name": "Pakur" },
          { "district_id": 224, "name": "Palamu" },
          { "district_id": 225, "name": "Ranchi" },
          { "district_id": 226, "name": "Sahibganj" },
          { "district_id": 227, "name": "Seraikela-Kharsawan" },
          { "district_id": 228, "name": "Simdega" },
          { "district_id": 229, "name": "West Singhbhum" }
        ]
      },
      {
        "state_id": 11,
        "name": "Karnataka",
        "districts": [
          { "district_id": 230, "name": "Bagalkot" },
          { "district_id": 231, "name": "Ballari" },
          { "district_id": 232, "name": "Belagavi" },
          { "district_id": 233, "name": "Bengaluru Rural" },
          { "district_id": 234, "name": "Bengaluru Urban" },
          { "district_id": 235, "name": "Bidar" },
          { "district_id": 236, "name": "Chamarajanagar" },
          { "district_id": 237, "name": "Chikballapur" },
          { "district_id": 238, "name": "Chikmagalur" },
          { "district_id": 239, "name": "Chitradurga" },
          { "district_id": 240, "name": "Dakshina Kannada" },
          { "district_id": 241, "name": "Davanagere" },
          { "district_id": 242, "name": "Dharwad" },
          { "district_id": 243, "name": "Gadag" },
          { "district_id": 244, "name": "Gulbarga" },
          { "district_id": 245, "name": "Hassan" },
          { "district_id": 246, "name": "Haveri" },
          { "district_id": 247, "name": "Kodagu" },
          { "district_id": 248, "name": "Kolar" },
          { "district_id": 249, "name": "Koppal" },
          { "district_id": 250, "name": "Mandya" },
          { "district_id": 251, "name": "Mysuru" },
          { "district_id": 252, "name": "Raichur" },
          { "district_id": 253, "name": "Ramanagara" },
          { "district_id": 254, "name": "Shimoga" },
          { "district_id": 255, "name": "Tumkur" },
          { "district_id": 256, "name": "Udupi" },
          { "district_id": 257, "name": "Uttar Kannada" },
          { "district_id": 258, "name": "Yadgir" }
        ]
      },
      {
        "state_id": 12,
        "name": "Kerala",
        "districts": [
          { "district_id": 259, "name": "Alappuzha" },
          { "district_id": 260, "name": "Ernakulam" },
          { "district_id": 261, "name": "Idukki" },
          { "district_id": 262, "name": "Kannur" },
          { "district_id": 263, "name": "Kasaragod" },
          { "district_id": 264, "name": "Kollam" },
          { "district_id": 265, "name": "Kottayam" },
          { "district_id": 266, "name": "Kozhikode" },
          { "district_id": 267, "name": "Malappuram" },
          { "district_id": 268, "name": "Palakkad" },
          { "district_id": 269, "name": "Pathanamthitta" },
          { "district_id": 270, "name": "Thiruvananthapuram" },
          { "district_id": 271, "name": "Thrissur" }
        ]
      },
      {
        "state_id": 13,
        "name": "Ladakh",
        "districts": [
          { "district_id": 272, "name": "Leh" },
          { "district_id": 273, "name": "Kargil" }
        ]
      },
      {
        "state_id": 14,
        "name": "Lakshadweep",
        "districts": [
          { "district_id": 274, "name": "Kavaratti" },
          { "district_id": 275, "name": "Agatti" },
          { "district_id": 276, "name": "Andrott" },
          { "district_id": 277, "name": "Amini" },
          { "district_id": 278, "name": "Kalapeni" },
          { "district_id": 279, "name": "Kiltan" },
          { "district_id": 280, "name": "Minicoy" },
          { "district_id": 281, "name": "Suheli" }
        ]
      },
      {
        "state_id": 15,
        "name": "Madhya Pradesh",
        "districts": [
          { "district_id": 284, "name": "Ashoknagar" },
          { "district_id": 285, "name": "Balaghat" },
          { "district_id": 286, "name": "Barwani" },
          { "district_id": 287, "name": "Betul" },
          { "district_id": 288, "name": "Bhind" },
          { "district_id": 289, "name": "Bhopal" },
          { "district_id": 290, "name": "Burhanpur" },
          { "district_id": 291, "name": "Chhindwara" },
          { "district_id": 292, "name": "Datiya" },
          { "district_id": 293, "name": "Dewas" },
          { "district_id": 294, "name": "Dhar" },
          { "district_id": 295, "name": "Guna" },
          { "district_id": 296, "name": "Gwalior" },
          { "district_id": 297, "name": "Harda" },
          { "district_id": 298, "name": "Hoshangabad" },
          { "district_id": 299, "name": "Jabalpur" },
          { "district_id": 300, "name": "Jhabua" },
          { "district_id": 301, "name": "Katni" },
          { "district_id": 302, "name": "Khandwa" },
          { "district_id": 303, "name": "Khargone" },
          { "district_id": 304, "name": "Mandla" },
          { "district_id": 305, "name": "Mandsaur" },
          { "district_id": 306, "name": "Morena" },
          { "district_id": 307, "name": "Narsinghpur" },
          { "district_id": 308, "name": "Neemuch" },
          { "district_id": 309, "name": "Pachmarhi" },
          { "district_id": 310, "name": "Panna" },
          { "district_id": 311, "name": "Raisen" },
          { "district_id": 312, "name": "Rajgarh" },
          { "district_id": 313, "name": "Ratlam" },
          { "district_id": 314, "name": "Rewa" },
          { "district_id": 315, "name": "Sagar" },
          { "district_id": 316, "name": "Satna" },
          { "district_id": 317, "name": "Sehore" },
          { "district_id": 318, "name": "Sewda" },
          { "district_id": 319, "name": "Shahdol" },
          { "district_id": 320, "name": "Shajapur" },
          { "district_id": 321, "name": "Sheopur" },
          { "district_id": 322, "name": "Shivpuri" },
          { "district_id": 323, "name": "Tikamgarh" },
          { "district_id": 324, "name": "Ujjain" },
          { "district_id": 325, "name": "Umaria" },
          { "district_id": 326, "name": "Vidisha" }
        ]
      },
      {
        "state_id": 16,
        "name": "Maharashtra",
        "districts": [
          { "district_id": 327, "name": "Ahmednagar" },
          { "district_id": 328, "name": "Akola" },
          { "district_id": 329, "name": "Amravati" },
          { "district_id": 330, "name": "Aurangabad" },
          { "district_id": 331, "name": "Beed" },
          { "district_id": 332, "name": "Bhandara" },
          { "district_id": 333, "name": "Buldhana" },
          { "district_id": 334, "name": "Chandrapur" },
          { "district_id": 335, "name": "Dhule" },
          { "district_id": 336, "name": "Gadchiroli" },
          { "district_id": 337, "name": "Gondia" },
          { "district_id": 338, "name": "Jalgaon" },
          { "district_id": 339, "name": "Jalna" },
          { "district_id": 340, "name": "Kolhapur" },
          { "district_id": 341, "name": "Latur" },
          { "district_id": 342, "name": "Mumbai City" },
          { "district_id": 343, "name": "Mumbai Suburban" },
          { "district_id": 344, "name": "Nagpur" },
          { "district_id": 345, "name": "Nanded" },
          { "district_id": 346, "name": "Nandurbar" },
          { "district_id": 347, "name": "Nashik" },
          { "district_id": 348, "name": "Osmanabad" },
          { "district_id": 349, "name": "Palghar" },
          { "district_id": 350, "name": "Parbhani" },
          { "district_id": 351, "name": "Pune" },
          { "district_id": 352, "name": "Ratnagiri" },
          { "district_id": 353, "name": "Sangli" },
          { "district_id": 354, "name": "Satara" },
          { "district_id": 355, "name": "Sindhudurg" },
          { "district_id": 356, "name": "Solapur" },
          { "district_id": 357, "name": "Thane" },
          { "district_id": 358, "name": "Wardha" },
          { "district_id": 359, "name": "Washim" },
          { "district_id": 360, "name": "Yavatmal" }
        ]
      },
      {
        "state_id": 17,
        "name": "Manipur",
        "districts": [
          { "district_id": 361, "name": "Bishnupur" },
          { "district_id": 362, "name": "Churachandpur" },
          { "district_id": 363, "name": "Imphal East" },
          { "district_id": 364, "name": "Imphal West" },
          { "district_id": 365, "name": "Jiribam" },
          { "district_id": 366, "name": "Kakching" },
          { "district_id": 367, "name": "Kangpokpi" },
          { "district_id": 368, "name": "Noney" },
          { "district_id": 369, "name": "Senapati" },
          { "district_id": 370, "name": "Tamenglong" },
          { "district_id": 371, "name": "Thoubal" },
          { "district_id": 372, "name": "Ukhrul" }
        ]
      },
      {
        "state_id": 18,
        "name": "Meghalaya",
        "districts": [
          { "district_id": 373, "name": "East Garo Hills" },
          { "district_id": 374, "name": "East Jaintia Hills" },
          { "district_id": 375, "name": "East Khasi Hills" },
          { "district_id": 376, "name": "North Garo Hills" },
          { "district_id": 377, "name": "Ri-Bhoi" },
          { "district_id": 378, "name": "South Garo Hills" },
          { "district_id": 379, "name": "South West Garo Hills" },
          { "district_id": 380, "name": "South West Khasi Hills" },
          { "district_id": 381, "name": "West Garo Hills" },
          { "district_id": 382, "name": "West Jaintia Hills" },
          { "district_id": 383, "name": "West Khasi Hills" }
        ]
      },
      {
        "state_id": 19,
        "name": "Mizoram",
        "districts": [
          { "district_id": 384, "name": "Aizawl" },
          { "district_id": 385, "name": "Champhai" },
          { "district_id": 386, "name": "Kolasib" },
          { "district_id": 387, "name": "Lawngtlai" },
          { "district_id": 388, "name": "Lunglei" },
          { "district_id": 389, "name": "Mamit" },
          { "district_id": 390, "name": "Serchhip" }
        ]
      },
      {
        "state_id": 20,
        "name": "Nagaland",
        "districts": [
          { "district_id": 391, "name": "Dimapur" },
          { "district_id": 392, "name": "Kiphire" },
          { "district_id": 393, "name": "Kohima" },
          { "district_id": 394, "name": "Mokokchung" },
          { "district_id": 395, "name": "Mon" },
          { "district_id": 396, "name": "Peren" },
          { "district_id": 397, "name": "Phek" },
          { "district_id": 398, "name": "Tuensang" },
          { "district_id": 399, "name": "Wokha" },
          { "district_id": 400, "name": "Zunheboto" }
        ]
      },
      {
        "state_id": 21,
        "name": "Odisha",
        "districts": [
          { "district_id": 401, "name": "Angul" },
          { "district_id": 402, "name": "Bargarh" },
          { "district_id": 403, "name": "Bargarh" },
          { "district_id": 404, "name": "Boudh" },
          { "district_id": 405, "name": "Cuttack" },
          { "district_id": 406, "name": "Dhenkanal" },
          { "district_id": 407, "name": "Gajapati" },
          { "district_id": 408, "name": "Ganjam" },
          { "district_id": 409, "name": "Jagatsinghpur" },
          { "district_id": 410, "name": "Jajpur" },
          { "district_id": 411, "name": "Jeypore" },
          { "district_id": 412, "name": "Kalahandi" },
          { "district_id": 413, "name": "Kandhamal" },
          { "district_id": 414, "name": "Kendrapara" },
          { "district_id": 415, "name": "Kendujhar" },
          { "district_id": 416, "name": "Khurda" },
          { "district_id": 417, "name": "Malkangiri" },
          { "district_id": 418, "name": "Nabarangpur" },
          { "district_id": 419, "name": "Nayagarh" },
          { "district_id": 420, "name": "Nuapada" },
          { "district_id": 421, "name": "Rayagada" },
          { "district_id": 422, "name": "Sambalpur" },
          { "district_id": 423, "name": "Subarnapur" },
          { "district_id": 424, "name": "Sundergarh" }
        ]
      },
      {
        "state_id": 22,
        "name": "Puducherry",
        "districts": [
          { "district_id": 425, "name": "Karaikal" },
          { "district_id": 426, "name": "Mahe" },
          { "district_id": 427, "name": "Puducherry" },
          { "district_id": 428, "name": "Yanam" }
        ]
      },
      {
        "state_id": 23,
        "name": "Punjab",
        "districts": [
          { "district_id": 429, "name": "Amritsar" },
          { "district_id": 430, "name": "Barnala" },
          { "district_id": 431, "name": "Bathinda" },
          { "district_id": 432, "name": "Faridkot" },
          { "district_id": 433, "name": "Fatehgarh Sahib" },
          { "district_id": 434, "name": "Fazilka" },
          { "district_id": 435, "name": "Firozpur" },
          { "district_id": 436, "name": "Hoshiarpur" },
          { "district_id": 437, "name": "Jalandhar" },
          { "district_id": 438, "name": "Kapurthala" },
          { "district_id": 439, "name": "Ludhiana" },
          { "district_id": 440, "name": "Mansa" },
          { "district_id": 441, "name": "Moga" },
          { "district_id": 442, "name": "Mohali" },
          { "district_id": 443, "name": "Muktsar" },
          { "district_id": 444, "name": "Nawanshahr" },
          { "district_id": 445, "name": "Pathankot" },
          { "district_id": 446, "name": "Patiala" },
          { "district_id": 447, "name": "Rupnagar" },
          { "district_id": 448, "name": "Sangrur" },
          { "district_id": 449, "name": "Sri Muktsar Sahib" },
          { "district_id": 450, "name": "Tarn Taran" }
        ]
      },
      {
        "state_id": 24,
        "name": "Rajasthan",
        "districts": [
          { "district_id": 451, "name": "Ajmer" },
          { "district_id": 452, "name": "Alwar" },
          { "district_id": 453, "name": "Banswara" },
          { "district_id": 454, "name": "Baran" },
          { "district_id": 455, "name": "Barmer" },
          { "district_id": 456, "name": "Bharatpur" },
          { "district_id": 457, "name": "Bhilwara" },
          { "district_id": 458, "name": "Bikaner" },
          { "district_id": 459, "name": "Bundi" },
          { "district_id": 460, "name": "Chittorgarh" },
          { "district_id": 461, "name": "Churu" },
          { "district_id": 462, "name": "Dausa" },
          { "district_id": 463, "name": "Dungarpur" },
          { "district_id": 464, "name": "Ganganagar" },
          { "district_id": 465, "name": "Hanumangarh" },
          { "district_id": 466, "name": "Jaipur" },
          { "district_id": 467, "name": "Jaisalmer" },
          { "district_id": 468, "name": "Jalore" },
          { "district_id": 469, "name": "Jhalawar" },
          { "district_id": 470, "name": "Jhunjhunu" },
          { "district_id": 471, "name": "Jodhpur" },
          { "district_id": 472, "name": "Karauli" },
          { "district_id": 473, "name": "Nagaur" },
          { "district_id": 474, "name": "Pali" },
          { "district_id": 475, "name": "Rajasthan" },
          { "district_id": 476, "name": "Sawai Madhopur" },
          { "district_id": 477, "name": "Sikar" },
          { "district_id": 478, "name": "Sirohi" },
          { "district_id": 479, "name": "Tonk" },
          { "district_id": 480, "name": "Udaipur" }
        ]
      },
      {
        "state_id": 25,
        "name": "Sikkim",
        "districts": [
          { "district_id": 481, "name": "East Sikkim" },
          { "district_id": 482, "name": "North Sikkim" },
          { "district_id": 483, "name": "South Sikkim" },
          { "district_id": 484, "name": "West Sikkim" }
        ]
      },
      {
        "state_id": 26,
        "name": "Tamil Nadu",
        "districts": [
          { "district_id": 485, "name": "Chennai" },
          { "district_id": 486, "name": "Coimbatore" },
          { "district_id": 487, "name": "Cuddalore" },
          { "district_id": 488, "name": "Dharmapuri" },
          { "district_id": 489, "name": "Dindigul" },
          { "district_id": 490, "name": "Erode" },
          { "district_id": 491, "name": "Kanchipuram" },
          { "district_id": 492, "name": "Kanyakumari" },
          { "district_id": 493, "name": "Karur" },
          { "district_id": 494, "name": "Madurai" },
          { "district_id": 495, "name": "Nagapattinam" },
          { "district_id": 496, "name": "Namakkal" },
          { "district_id": 497, "name": "Perambalur" },
          { "district_id": 498, "name": "Pudukkottai" },
          { "district_id": 499, "name": "Ramanathapuram" },
          { "district_id": 500, "name": "Salem" },
          { "district_id": 501, "name": "Sivagangai" },
          { "district_id": 502, "name": "Thanjavur" },
          { "district_id": 503, "name": "The Nilgiris" },
          { "district_id": 504, "name": "Tiruchirappalli" },
          { "district_id": 505, "name": "Tirunelveli" },
          { "district_id": 506, "name": "Tiruppur" },
          { "district_id": 507, "name": "Vellore" },
          { "district_id": 508, "name": "Virudhunagar" }
        ]
      },
      {
        "state_id": 27,
        "name": "Telangana",
        "districts": [
          { "district_id": 509, "name": "Adilabad" },
          { "district_id": 510, "name": "Bhadradri Kothagudem" },
          { "district_id": 511, "name": "Hyderabad" },
          { "district_id": 512, "name": "Jagtial" },
          { "district_id": 513, "name": "Jangaon" },
          { "district_id": 514, "name": "Jangaon" },
          { "district_id": 515, "name": "Jayashankar" },
          { "district_id": 516, "name": "Jogulamba Gadwal" },
          { "district_id": 517, "name": "Kamareddy" },
          { "district_id": 518, "name": "Karimnagar" },
          { "district_id": 519, "name": "Khammam" },
          { "district_id": 520, "name": "Mahabubabad" },
          { "district_id": 521, "name": "Mahabubnagar" },
          { "district_id": 522, "name": "Mancherial" },
          { "district_id": 523, "name": "Medak" },
          { "district_id": 524, "name": "Medchal" },
          { "district_id": 525, "name": "Nalgonda" },
          { "district_id": 526, "name": "Nirmal" },
          { "district_id": 527, "name": "Nizamabad" },
          { "district_id": 528, "name": "Peddapalli" },
          { "district_id": 529, "name": "Rajanna Sircilla" },
          { "district_id": 530, "name": "Rangareddy" },
          { "district_id": 531, "name": "Warangal" }
        ]
      },
      {
        "state_id": 28,
        "name": "Tripura",
        "districts": [
          { "district_id": 532, "name": "Dhalai" },
          { "district_id": 533, "name": "Khowai" },
          { "district_id": 534, "name": "North Tripura" },
          { "district_id": 535, "name": "Sepahijala" },
          { "district_id": 536, "name": "South Tripura" },
          { "district_id": 537, "name": "Unakoti" },
          { "district_id": 538, "name": "West Tripura" }
        ]
      },
      {
        "state_id": 29,
        "name": "Uttar Pradesh",
        "districts": [
          { "district_id": 539, "name": "Agra" },
          { "district_id": 540, "name": "Aligarh" },
          { "district_id": 541, "name": "Ambedkar Nagar" },
          { "district_id": 542, "name": "Amethi" },
          { "district_id": 543, "name": "Amroha" },
          { "district_id": 544, "name": "Auraiya" },
          { "district_id": 545, "name": "Ayodhya" },
          { "district_id": 546, "name": "Azamgarh" },
          { "district_id": 547, "name": "Badaun" },
          { "district_id": 548, "name": "Baghpat" },
          { "district_id": 549, "name": "Bahraich" },
          { "district_id": 550, "name": "Baliya" },
          { "district_id": 551, "name": "Balrampur" },
          { "district_id": 552, "name": "Banda" },
          { "district_id": 553, "name": "Barabanki" },
          { "district_id": 554, "name": "Bareilly" },
          { "district_id": 555, "name": "Basti" },
          { "district_id": 556, "name": "Bhadohi" },
          { "district_id": 557, "name": "Bijnor" },
          { "district_id": 558, "name": "Budaun" },
          { "district_id": 559, "name": "Bulandshahr" },
          { "district_id": 560, "name": "Chandauli" },
          { "district_id": 561, "name": "Chitrakoot" },
          { "district_id": 562, "name": "Deoria" },
          { "district_id": 563, "name": "Etah" },
          { "district_id": 564, "name": "Etawah" },
          { "district_id": 565, "name": "Faizabad" },
          { "district_id": 566, "name": "Farrukhabad" },
          { "district_id": 567, "name": "Fatehpur" },
          { "district_id": 568, "name": "Firozabad" },
          { "district_id": 569, "name": "Gautam Buddha Nagar" },
          { "district_id": 570, "name": "Ghaziabad" },
          { "district_id": 571, "name": "Gonda" },
          { "district_id": 572, "name": "Gorakhpur" },
          { "district_id": 573, "name": "Hamirpur" },
          { "district_id": 574, "name": "Hapur" },
          { "district_id": 575, "name": "Hardoi" },
          { "district_id": 576, "name": "Hathras" },
          { "district_id": 577, "name": "Jalaun" },
          { "district_id": 578, "name": "Jaunpur" },
          { "district_id": 579, "name": "Jhansi" },
          { "district_id": 580, "name": "Kannauj" },
          { "district_id": 581, "name": "Kanpur" },
          { "district_id": 582, "name": "Kaushambi" },
          { "district_id": 583, "name": "Kushinagar" },
          { "district_id": 584, "name": "Lakhimpur Kheri" },
          { "district_id": 585, "name": "Lucknow" },
          { "district_id": 586, "name": "Mau" },
          { "district_id": 587, "name": "Meerut" },
          { "district_id": 588, "name": "Mirzapur" },
          { "district_id": 589, "name": "Moradabad" },
          { "district_id": 590, "name": "Muzaffarnagar" },
          { "district_id": 591, "name": "Pilibhit" },
          { "district_id": 592, "name": "Pratapgarh" },
          { "district_id": 593, "name": "Raebareli" },
          { "district_id": 594, "name": "Rampur" },
          { "district_id": 595, "name": "Saharanpur" },
          { "district_id": 596, "name": "Sitapur" },
          { "district_id": 597, "name": "Sonbhadra" },
          { "district_id": 598, "name": "Sultanpur" },
          { "district_id": 599, "name": "Unnao" },
          { "district_id": 600, "name": "Varanasi" }
        ]
      },
      {
        "state_id": 30,
        "name": "Uttarakhand",
        "districts": [
          { "district_id": 601, "name": "Almora" },
          { "district_id": 602, "name": "Bageshwar" },
          { "district_id": 603, "name": "Chamoli" },
          { "district_id": 604, "name": "Champawat" },
          { "district_id": 605, "name": "Dehradun" },
          { "district_id": 606, "name": "Haridwar" },
          { "district_id": 607, "name": "Nainital" },
          { "district_id": 608, "name": "Pauri Garhwal" },
          { "district_id": 609, "name": "Pithoragarh" },
          { "district_id": 610, "name": "Rudraprayag" },
          { "district_id": 611, "name": "Tehri Garhwal" },
          { "district_id": 612, "name": "Udham Singh Nagar" },
          { "district_id": 613, "name": "Uttarkashi" }
        ]
      },
      {
        "state_id": 31,
        "name": "West Bengal",
        "districts": [
          { "district_id": 614, "name": "Alipurduar" },
          { "district_id": 615, "name": "Bankura" },
          { "district_id": 616, "name": "Bardhaman" },
          { "district_id": 617, "name": "Birbhum" },
          { "district_id": 618, "name": "Burdwan" },
          { "district_id": 619, "name": "Cooch Behar" },
          { "district_id": 620, "name": "Dakshin Dinajpur" },
          { "district_id": 621, "name": "Darjeeling" },
          { "district_id": 622, "name": "Hooghly" },
          { "district_id": 623, "name": "Howrah" },
          { "district_id": 624, "name": "Jalpaiguri" },
          { "district_id": 625, "name": "Jhargram" },
          { "district_id": 626, "name": "Kalimpong" },
          { "district_id": 627, "name": "Kolkata" },
          { "district_id": 628, "name": "Malda" },
          { "district_id": 629, "name": "Murarai" },
          { "district_id": 630, "name": "Nadia" },
          { "district_id": 631, "name": "North 24 Parganas" },
          { "district_id": 632, "name": "Purba Bardhaman" },
          { "district_id": 633, "name": "Purulia" },
          { "district_id": 634, "name": "South 24 Parganas" },
          { "district_id": 635, "name": "Uttar Dinajpur" }
        ]
      },
      {
        "state_id": 32,
        "name": "Andaman and Nicobar Islands",
        "districts": [
          { "district_id": 636, "name": "Andaman" },
          { "district_id": 637, "name": "Nicobar" }
        ]
      },
      {
        "state_id": 33,
        "name": "Chandigarh",
        "districts": [
          { "district_id": 638, "name": "Chandigarh" }
        ]
      },
      {
        "state_id": 34,
        "name": "Dadra and Nagar Haveli and Daman and Diu",
        "districts": [
          { "district_id": 639, "name": "Dadra and Nagar Haveli" },
          { "district_id": 640, "name": "Daman" },
          { "district_id": 641, "name": "Diu" }
        ]
      }
   
]

export default statesWithDistricts;